module.exports = __webpack_public_path__ + "static/media/mission-photo.e6f0ade0.png";